import { COMPONENT_TYPES } from '../../../constants';
import OrderHistoryComponent from './OrderHistory.component';
import OrderHistoryEditor from './OrderHistory.editor';
import OrderHistoryProperties from './OrderHistory.properties';
import { registerComponent } from '../registry';

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.ORDER_HISTORY, // constants.js에 정의된 타입 상수 사용
  component: OrderHistoryComponent,
  editorComponent: OrderHistoryEditor,
  properties: OrderHistoryProperties,
  defaultProps: {
    // 기본 속성 정의
    style: {
      width: '100%',
      padding: '40px 0',
      backgroundColor: '#f9f9fb'
    },
    componentProps: {
      className: "order-history-wrapper padding-tb-40",
      title: "주문 내역",
      emptyText: "주문 내역이 없습니다."
    }
  },
  category: 'order', // 컴포넌트 카테고리
  icon: '📦', // 대표 아이콘
  name: '주문 내역' // 표시할 이름
});

// 컴포넌트 및 타입 내보내기
export { default as OrderHistoryComponent } from './OrderHistory.component';
export { default as OrderHistoryEditor } from './OrderHistory.editor';
export { default as OrderHistoryProperties } from './OrderHistory.properties';
export * from './OrderHistory.types'; 